// extracted by mini-css-extract-plugin
export default {"button":"FavoriteButton__button--slots-RQuf0","button_sc":"FavoriteButton__button_sc--slots-RJgnw","loading":"FavoriteButton__loading--slots-zO6IW"};